export default __webpack_public_path__ + "51bacd9fb409785d6dd1984ee17dba70.svg";